import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: white;
  flex: 1 1 auto;
  margin: 16px;
`

const TitleWrapper = styled.div`
  max-width: ${(props) => props.width};
  line-height: 1.27;
  text-align: center;
  font-size: 24px;
  color: black;
  padding-top: 20px;
  padding-bottom: 10px;
  font-family: BlocketSans-Medium, sans-serif;
`

const MessageWrapper = styled.div`
  max-width: ${(props) => props.width};
  line-height: 1.62;
  text-align: center;
  color: black;
  font-size: 16px;
  padding-bottom: 20px;
`

const EmptyState = ({ children, width = 280 }) => {
  const childArray = React.Children.toArray(children)
  const lastChildren = childArray.slice(3)
  return (
    <Container>
      {childArray[0]}
      <TitleWrapper width={width}>{childArray[1]}</TitleWrapper>
      <MessageWrapper>{childArray[2]}</MessageWrapper>
      {lastChildren.map((child) => (
        <div key={`${child.key}Wrapper`}>{child}</div>
      ))}
    </Container>
  )
}

/* eslint-disable no-confusing-arrow */
EmptyState.propTypes = {
  children: (props, propName, componentName) =>
    React.Children.count(props[propName]) >= 3
      ? null
      : new Error(`${componentName} must receive at least 3 child components`),
  width: PropTypes.number,
}

export default EmptyState
